import { AnsweredTile } from '../AnsweredTile';
import type { StyleTilesReply } from './parseReply';

type StyleTilesMessageViewProps = {
    data: StyleTilesReply;
};

/**
 * The settled, read-only answer for a style-tiles turn: the tile the customer picked, shown
 * inside their own message bubble. Renders the shared `AnsweredTile` card — see that component
 * for why it isn't a SWAN `StandardTile`.
 */
export function StyleTilesMessageView({ data }: StyleTilesMessageViewProps) {
    return <AnsweredTile imageUrl={data.imageUrl} name={data.name} />;
}
